/**
 * Lightweight JWT exp decoder. No external dependency — JWTs use base64url
 * which we normalize to base64 before decoding.
 *
 * Returns the `exp` claim (seconds since epoch) or null if the token is
 * missing / malformed / has no exp claim.
 */
export const decodeJwtExp = (token) => {
  if (!token || typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length !== 3) return null;

  try {
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = payload + "===".slice((payload.length + 3) % 4);
    const json = atob(padded);
    const parsed = JSON.parse(json);
    return typeof parsed?.exp === "number" ? parsed.exp : null;
  } catch {
    return null;
  }
};

/**
 * Returns the milliseconds remaining until the JWT expires, or null if the
 * token has no exp claim. Negative if already expired.
 */
export const jwtExpiresInMs = (token) => {
  const exp = decodeJwtExp(token);
  if (exp == null) return null;
  return exp * 1000 - Date.now();
};